import * as yup from 'yup';

import {
  clientSchema,
  NO_SALUTATION_SELECTED,
} from '@/features/Clients/Schemas/Base';
import { locales } from '@/features/validation/locales';
import { hasMitversichertePerson } from '@/features/Contract/Shared/sharedConditions';

yup.setLocale(locales);

export const MitversicherterPartnerPropertySchema = clientSchema.concat(
  yup.object({
    anredeId: yup.number().when({
      is: () => hasMitversichertePerson.value,
      then: yup.number().required().notOneOf([NO_SALUTATION_SELECTED]),
    }),

    vorname: yup.string().when({
      is: () => hasMitversichertePerson.value,
      then: yup.string().required(),
    }),
    nachname: yup.string().when({
      is: () => hasMitversichertePerson.value,
      then: yup.string().required(),
    }),
    geburtsdatum: yup
      .date()
      .nullable()
      .default(null)
      .when({
        is: () => hasMitversichertePerson.value,
        then: yup.date().required(),
      }),
  }),
);
